"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var currentSubscription = exports.currentSubscription = function currentSubscription(state) {
  return state.user.loggedIn && state.entities.subscription.data.default ? state.entities.subscription.data.default.current_subscription : null;
};